function run() {
    // BTN TO TOP
    $("#btn_bottom").remove();

    if ($(window).height() > $(window).width()) {
        import(/* webpackChunkName: "mobileClass" */"./customizationfrontmobile.js").then(mobileClass => {
            customizationfrontmobile = mobileClass.default;
            mobile = new customizationfrontmobile();
            mobile.init();
        });
    }
    else {
        import(/* webpackChunkName: "desktopClass" */"./customizationfrontdesktop.js").then(desktopClass => {
            customizationfrontdesktop = desktopClass.default;
            desktop = new customizationfrontdesktop();
            desktop.init();
        });
    }
}
run();